import ky from 'ky'
import { getWebVersion } from 'web/src/shared/getWebVersion'
import { API_BASE_URL } from '@mote/config/constants'
import { __DEV__, __STORYBOOK__ } from '@mote/helpers/constants'
import { Diagnostics, DiagnosticsLogger } from '@mote/helpers/diagnostics'
import { getExtensionVersion, isInExtension } from '@mote/helpers/extension'
import {
  forceLogout,
  getAccessToken,
  getDeviceId,
  getDeviceIdOrAccessTokenHash,
  getLastUserId,
  handleResponseAuthData
} from '@mote/helpers/identity'
import window from '@mote/helpers/injectChromeObject'

const logD = new DiagnosticsLogger('NetworkRequest', 'Transport')

/**
 * @param {Request} request
 */
export function beforeRequestHook(request) {
  const accessToken = getAccessToken()
  const deviceId = getDeviceId()

  if (accessToken) {
    request.headers.set('mote-access-token', accessToken)
  }

  if (deviceId) {
    request.headers.set('mote-device-id', deviceId)
  }

  request.headers.set(
    'mote-client-version',
    isInExtension() ? getExtensionVersion() : getWebVersion()
  )
  request.headers.set(
    'mote-client-type',
    isInExtension() ? 'extension' : 'website'
  )
  request.headers.set('mote-last-user-id', getLastUserId())
}

export async function afterResponseHandler(request, options, response) {
  if (__STORYBOOK__) {
    return
  }

  if (!response) return null

  try {
    if (response.status === 403 && !options.shouldPropagate403) {
      if (isInExtension()) {
        await window.chrome.runtime.sendMessage({ type: 'logout' })
        return
      }

      const params = new URLSearchParams({
        force: '1',
        error: '403',
        returnTo: window.location.pathname
      })
      const url = `${window.location.origin}/login?${params.toString()}`
      window.location.replace(url)

      return
    }

    if (
      response.status >= 400 &&
      !(response.status === 403 && options.shouldPropagate403)
    ) {
      return
    }

    //TODO: Change this - responses can be different type only only json
    const res = await response.json()

    if (options.shouldNotStoreAuthData) {
      return
    }

    if (
      res.auth &&
      !res.auth.isLoggedIn &&
      Boolean(getDeviceIdOrAccessTokenHash()?.accessToken)
    ) {
      logD.info('User was logged out, deleting token', {
        lastUserId: getLastUserId()
      })
      Diagnostics.dispatch({
        dispatchContext: 'NETWORK_TRANSPORT',
        title: 'Logged out user with invalid access token'
      })
      forceLogout()
      return
    }

    handleResponseAuthData(res, response.url)
  } catch (err) {
    if (__DEV__) console.error('DEV_ONLY', response, err)
  }

  return null
}

export const apiClient = ky.extend({
  prefixUrl: API_BASE_URL,
  hooks: {
    beforeRequest: [beforeRequestHook],
    afterResponse: [afterResponseHandler]
  }
})
